import React from 'react';

import SimpleSearchField from '~/components/core/SimpleSearchField';
import { LobMultiSelect } from '~/components/TPA/LOB/LobMultiselect';
import SubOrganizationMultiSelect from '~/components/TPA/SubOrganizations/SubOrganizationMultiSelect';
import cn from '~/Utils/cn';

import type { SysconfigOrganization } from '../types';

interface FundAccountRulesFiltersProps {
  organization: SysconfigOrganization;
  subOrgIds: number[];
  onSearchTermChanged: (searchTerm: string) => void;
  onSubOrgChanged: (subOrgIds: number[]) => void;
  onLobsChanged: (lobs: string[]) => void;
}

const FundAccountRulesFilters: React.FC<FundAccountRulesFiltersProps> = ({
  organization,
  subOrgIds,
  onSearchTermChanged,
  onSubOrgChanged,
  onLobsChanged,
}) => (
  // Column count follows the fields actually rendered: a flat organization has no sub-org select,
  // and a fixed three-track grid would leave it a dead trailing column.
  <div
    className={cn(
      'grid items-end gap-16 pb-32',
      organization.sub_organizations_enabled ? 'grid-cols-3' : 'grid-cols-2'
    )}
  >
    {/* `my-[3px]` matches the vertical margin the other two fields set internally, so the three
        baselines line up under `items-end`. */}
    <SimpleSearchField label="Search Rule" placeholder="Search" className="my-[3px]" onChange={onSearchTermChanged} />
    {organization.sub_organizations_enabled && <SubOrganizationMultiSelect onChange={onSubOrgChanged} />}
    <LobMultiSelect
      // `LobMultiSelect` is an untyped JS component whose `subOrganizationIds` PropTypes.array
      // infers as `never[]`, which `number[]` is not assignable to. Suppressed rather than cast:
      // a cast would keep compiling once that component gains real types, hiding the fact that the
      // workaround is obsolete, whereas this directive turns into an "unused" error (TS2578) the
      // day the underlying type is fixed.
      // @ts-expect-error -- untyped JS component: PropTypes.array infers as never[]
      subOrganizationIds={subOrgIds}
      onChange={onLobsChanged}
    />
  </div>
);

export default FundAccountRulesFilters;
